import { render, staticRenderFns } from "./RecommendationsView.vue?vue&type=template&id=703db8bd&"
import script from "./RecommendationsView.vue?vue&type=script&lang=js&"
export * from "./RecommendationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports